import React from 'react';
import { usePageContent } from '../hooks/usePageContent';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';

const TradingSteps = () => {
  const { handleButtonClick } = useButtonLinks();
  const { t } = useTranslation();

  return (
    <section className="trading-steps">
      <div className="container">
        <div className="steps-header">
          <h2 className="section-title">
            {t('tradingSteps.title')}
            <span className="title-accent">.</span>
          </h2>
        </div>
        
        <div className="steps-container">
          <div className="step-item">
            <div className="step-icon">
              <i className="fas fa-user-plus"></i>
            </div>
            <h3 className="step-title">{t('tradingSteps.step1Title')}</h3>
            <p className="step-description">
              {t('tradingSteps.step1Description')}
            </p>
          </div>
          
          <div className="step-item">
            <div className="step-icon">
              <i className="fas fa-coins"></i>
            </div>
            <h3 className="step-title">{t('tradingSteps.step2Title')}</h3>
            <p className="step-description">
              {t('tradingSteps.step2Description')}
            </p>
          </div>
          
          <div className="step-item">
            <div className="step-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3 className="step-title">{t('tradingSteps.step3Title')}</h3>
            <p className="step-description">
              {t('tradingSteps.step3Description')}
            </p>
          </div>
        </div>
        
        <div className="steps-cta">
          <button 
            className="btn btn-primary"
            onClick={(e) => handleButtonClick('getStarted', e)}
          >
            {t('tradingSteps.getStartedButton')}
          </button>
          <button 
            className="btn btn-secondary"
            onClick={(e) => handleButtonClick('learnMore', e)}
          >
            {t('tradingSteps.learnMoreButton')}
          </button>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="steps-decoration decoration-1"></div>
      <div className="steps-decoration decoration-2"></div>
    </section>
  );
};

export default TradingSteps;